module.exports = __webpack_public_path__ + "img/urology.aa3e4276.svg";